import { withBrowserContext } from '../../../utils/localizationContext/withBrowserContext';
import { currencyFormat as currencyFormatBase } from '../../../utils/formatters/currency';

export { CURRENCY_STYLES } from '../../../utils/formatters/currency';
export const currencyFormat = withBrowserContext(currencyFormatBase);
